// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fp0oja0 {
  width: 100%;
  display: inline-flex;
  top: unset;
  position: unset;
  align-items: center;
  gap: 12px;
  justify-content: center;
}
.fp0oja1 {
  bottom: 12px !important;
  width: 100%;
  display: inline-flex;
  top: auto;
  align-items: center;
  gap: 16px;
  justify-content: center;
  position: absolute;
}
.fp0oja2 {
  width: 200% !important;
  display: inline-flex;
  top: 50%;
  transform: translateY(-50%);
  align-items: center;
  gap: 16px;
  justify-content: space-between !important;
  position: absolute;
  left: -50% !important;
  z-index: 0;
}
.fp0oja3 {
  width: 12px;
  height: 12px;
  border-radius: 100%;
}
.fp0oja6 {
  border: 2px solid white;
}
.fp0oja8 {
  width: 14px;
  height: 14px;
  border: 1px solid white;
  position: relative;
  top: 1px;
}
.fp0oja9 {
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: inset 0px 0px 0px 2px rgba(255, 255, 255, 0.7);
}
.fp0ojaa {
  opacity: 0.9;
}
.fp0ojab {
  justify-content: center;
  align-items: center;
  border: none;
  padding-left: 0;
  padding-right: 0;
  cursor: pointer;
}
.fp0ojac {
  width: auto;
  height: auto;
}
.fp0ojad {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,oCAAoC;EACpC,0DAA0D;AAC5D;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".fp0oja0 {\n  width: 100%;\n  display: inline-flex;\n  top: unset;\n  position: unset;\n  align-items: center;\n  gap: 12px;\n  justify-content: center;\n}\n.fp0oja1 {\n  bottom: 12px !important;\n  width: 100%;\n  display: inline-flex;\n  top: auto;\n  align-items: center;\n  gap: 16px;\n  justify-content: center;\n  position: absolute;\n}\n.fp0oja2 {\n  width: 200% !important;\n  display: inline-flex;\n  top: 50%;\n  transform: translateY(-50%);\n  align-items: center;\n  gap: 16px;\n  justify-content: space-between !important;\n  position: absolute;\n  left: -50% !important;\n  z-index: 0;\n}\n.fp0oja3 {\n  width: 12px;\n  height: 12px;\n  border-radius: 100%;\n}\n.fp0oja6 {\n  border: 2px solid white;\n}\n.fp0oja8 {\n  width: 14px;\n  height: 14px;\n  border: 1px solid white;\n  position: relative;\n  top: 1px;\n}\n.fp0oja9 {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0px 0px 0px 2px rgba(255, 255, 255, 0.7);\n}\n.fp0ojaa {\n  opacity: 0.9;\n}\n.fp0ojab {\n  justify-content: center;\n  align-items: center;\n  border: none;\n  padding-left: 0;\n  padding-right: 0;\n  cursor: pointer;\n}\n.fp0ojac {\n  width: auto;\n  height: auto;\n}\n.fp0ojad {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
